import React, { Component } from 'react';
import { connect } from "react-redux";
import ModalDiseasesForm from './modal-diseases-form'
import ModalConfirmDelete from "./modal-confirm-delete";
import SkipLogicBreastView from './skip-logic-breast-view'
import SkipLogicColerectalView from './skip-logic-colorectal-view'
import SkipLogicColerectalPolypsView from './skip-logic-colorectal-polyps-view'
import SkipLogicMelanomaView from './skip-logic-melanoma-view'
import SkipLogicHodgkinLymphomaView from './skip-logic-hodgkin-lymphoma-view'
import SkipLogicDCISView from './skip-logic-dcis-view'
import SkipLogicPancreaticNeuroendocrineView from './skip-logic-pancreatic-neuroendocrine-view'
import SkipLogicProstateView from './skip-logic-prostate-view'
import SkipLogicThyroidView from './skip-logic-thyroid-view'
import SkipLogicUterineView from './skip-logic-uterine-view'
import SkipLogicLeukemiaView from './skip-logic-leukemia-view'
import SkipLogicBirthDefectsView from './skip-logic-birth-defects-view'
import SkipLogicOtherCancerView from './skip-logic-other-cancer-view';
import { cloneDeep } from "lodash";

import * as patient_actions from "../store/patient/actions";
import disease_api from "../api/disease-api";
import { createUUID } from './react-flow-pedigree/utils';


class PatientDiseaseView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showModalDiseases: false,
      selectedDisease: null,
      modalDiseaseTitle: '',
      errorMessages: [],
      openModalConfirmDelete: false,
      loading_delete: false,
      modalConfirmDeleteHash: null
    }

    this.handleClickAddDisease = this.handleClickAddDisease.bind(this)
    this.handleEditDisease = this.handleEditDisease.bind(this)
    this.disableAddForReadOnly = this.disableAddForReadOnly.bind(this)
  }

  async handleClickAddDisease() {
    if('onBeforeAddDisease' in this.props) {
      var ok = await this.props.onBeforeAddDisease();
      if(ok) {
        this.setState({showModalDiseases: true, selectedDisease: null, modalDiseaseTitle: 'Add Disease'})
      }
    } else {
      this.setState({showModalDiseases: true, selectedDisease: null, modalDiseaseTitle: 'Add Disease'})
    }
  }

  getDiseases() {
    let history_diseases = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().diseases : this.props.history_diseases
    if(this.props.patientRkey in history_diseases) {
      let diseases = history_diseases[this.props.patientRkey];
      for(let i=0; i<diseases.length; i++) if(diseases[i].rkey === null || diseases[i].rkey === undefined) diseases[i].rkey = createUUID();
        console.log(diseases)
      return diseases;
    }
    return []
  }

  diseaseGroup(id) {
    if(1 <= id <= 43) {
      return 'Cancer';
    } else {
      return 'Other Conditions';
    }
  }

  handleEditDisease(selectedDisease) {
    this.setState({showModalDiseases: true, selectedDisease, modalDiseaseTitle: 'Edit Disease'})
  }

  onModalDiseaseSave(data) {
    if('onDiseaseUpdate' in this.props) this.props.onDiseaseUpdate(data);
    this.setState({showModalDiseases: false});
  }

  onModalDiseaseDelete() {
    if('onDiseaseUpdate' in this.props) this.props.onDiseaseUpdate();
    this.setState({showModalDiseases: false});
    if(this.state.openModalConfirmDelete === true) this.setState({openModalConfirmDelete: false})
  }

  async onClickDelete() {
    try {
      this.setState({ errorMessages: [], loading_delete: true });

      // delete_member_disease_id
      if (this.state.selectedDisease.id !== null) {
        await disease_api.delete_member_disease_id(this.state.selectedDisease.id);
      }

      if(this.props.getPedigreeData !== undefined && this.props.getPedigreeData !== null){
        let diseases = cloneDeep(this.props.getPedigreeData().getDiseases(this.props.patientRkey))
        let profile_proband = cloneDeep(this.props.getPedigreeData().getProfile(this.props.patientRkey))
        diseases = diseases.filter(disease => disease.id !== this.state.selectedDisease.id)
        profile_proband.diseases = diseases;
        await this.props.getPedigreeData().setDiseases(this.props.patientRkey, diseases)
        await this.props.getPedigreeData().setProfile(this.props.patientRkey, profile_proband)
      }
      else{
        this.props.dispatch(
          patient_actions.delete_history_disease_detail({
            ownerRkey: this.props.patientRkey,
            disease_rkey: this.state.selectedDisease.rkey
          })
        );
      }

      if('onDiseaseUpdate' in this.props) {
        this.onModalDiseaseDelete()
      } else {
        this.setState({openModalConfirmDelete: false});
        if (this.state.showModalDiseases) this.setState({ showModalDiseases: false });
      }

    } catch (error) {
      console.log(error.stack)
      this.setState({ errorMessages: [error.message] });
    } finally {
      this.setState({ loading_delete: false });
    }
  }

  onClickOpenModalConfirmDelete(selectedDisease) {
    this.setState({
      selectedDisease,
      openModalConfirmDelete: true,
      modalConfirmDeleteHash: new Date().getTime()
    });
  }
  disableAddForReadOnly(){
    if(this.props.read_only && this.props.read_only === true){
      return false
    }
    return true
  }

  render() {
    return (
      <React.Fragment>
        <div className="row col-md-6 pull-left margin-one" style={{paddingRight: "2%"}}>
          <div className="col-md-12 margin-one no-margin-top">
            <div className={(this.props.sideBar ? "form-header-2" : "form-header")}>
              <div className="row vcenter">
                <div className="col-md-6 ">
                  <h3 className={"title " + (this.props.sideBar ? 'text--uppercase' : '')}>Diseases</h3>
                </div>
              {this.disableAddForReadOnly() &&(
                <div className="col-md-6 ">
                    <a className="btn btn-teal btn-xs" onClick={this.handleClickAddDisease}><i className="fa fa-plus"></i> Add</a>
                </div>
              )}
              </div>
            </div>
            <div className="panel-col">

              {this.getDiseases().map(item =>

                <div key={item.rkey} className={"panel-summary " + (this.props.sideBar ? 'width--full' : '')}>
                {this.disableAddForReadOnly() &&(
                  <>
                  <a className="panel-summary-edit" onClick={() => this.handleEditDisease(item)}><i className="fa fa-pencil-square-o"></i></a>
                  <a className="panel-summary-delete" onClick={() => this.onClickOpenModalConfirmDelete(item)}><i className="fa fa-trash"></i></a>
                </>
                )}
                  <h4>{item.disease_name} Dx {item.age_diagnosed_string ? item.age_diagnosed_string : item.age_diagnosed ? item.age_diagnosed : '?'  }</h4>

                  {item.disease_code == 'D002' &&
                    <SkipLogicBreastView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == 'D003' &&
                    <SkipLogicColerectalView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == 'D004' &&
                    <SkipLogicColerectalPolypsView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == 'D008' &&
                    <SkipLogicMelanomaView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == 'D030' &&
                    <SkipLogicHodgkinLymphomaView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == "D005" &&
                    <SkipLogicDCISView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == "D033" &&
                    <SkipLogicPancreaticNeuroendocrineView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == "D011" &&
                    <SkipLogicProstateView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == "D015" &&
                    <SkipLogicThyroidView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == "D017" &&
                    <SkipLogicUterineView skipLogics={item.skip_logics} />
                  }

                  {item.disease_code == 'D007' &&
                    <SkipLogicLeukemiaView skipLogics={item}/>
                  }
                  {item.disease_code == 'D079' &&
                    <SkipLogicBirthDefectsView skipLogics={item} />
                  }
                  {item.disease_code == 'D107' &&
                    <SkipLogicOtherCancerView skipLogics={item} />
                  }
                </div>
              )}

            </div>
          </div>
        </div>

        {this.state.openModalConfirmDelete && (
          <ModalConfirmDelete
            title="Delete Disease"
            message="Do you want to delete this disease?"
            isOpen={this.state.openModalConfirmDelete}
            onCancel={() => this.setState({ openModalConfirmDelete: false })}
            onOk={() => this.onClickDelete()}
            loading={this.state.loading_delete}
            errorMessages={this.state.errorMessages}
          />
        )}


        {this.state.showModalDiseases &&
          <ModalDiseasesForm
            title={this.state.modalDiseaseTitle}
            patientRkey={this.props.patientRkey}
            profile={this.props.profile}
            disease={this.state.selectedDisease}
            onClose={() => this.setState({showModalDiseases: false})}
            onCancel={() => this.setState({showModalDiseases: false})}
            onSave={(data) => this.onModalDiseaseSave(data)}
            onDelete={() => this.onModalDiseaseDelete()}
            getPedigreeData={this.props.getPedigreeData}
          />
        }

      </React.Fragment>
    )
  }
}

const redux_state = state => ({
  history_diseases: state.patient.history_diseases,
  history_genes: state.patient.history_genes
});

const redux_actions = dispatch => ({
  dispatch: (action) => dispatch(action)
});

export default connect(redux_state, redux_actions)(PatientDiseaseView);
